var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.15C24.6351 10.15 25.15 9.63513 25.15 9C25.15 8.36487 24.6351 7.85 24 7.85V10.15ZM1.18683 8.18683C0.737724 8.63593 0.737724 9.36407 1.18683 9.81317L8.50538 17.1317C8.95448 17.5808 9.68262 17.5808 10.1317 17.1317C10.5808 16.6826 10.5808 15.9545 10.1317 15.5054L3.62634 9L10.1317 2.49462C10.5808 2.04551 10.5808 1.31738 10.1317 0.868272C9.68262 0.419169 8.95448 0.419169 8.50538 0.868272L1.18683 8.18683ZM24 7.85L2 7.85V10.15L24 10.15V7.85Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.7b06868a69c067828d5255048c008824.svg";
export { ForwardRef as ReactComponent };